import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CloudDownload } from '@mui/icons-material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import './Drawer.css'; // Ensure you're using your CSS for styling

const Drawer = ({ isOpen, onClose, set1, set2, handleUpload, candidateuuid, baseUrl }) => {
  const triggerFileInput1 = (idx) => {
    document.getElementById(`fileInput1-${idx}`).click();
  };
  const triggerFileInput2 = (idx) => {
    document.getElementById(`fileInput2-${idx}`).click();
  };

  const handleFileChange = (event, docid) => {
    handleUpload(event.target.files[0], docid)
  };

  return (
    <div className={`drawer ${isOpen ? 'open' : ''}`}>
      <button className="close-btn" onClick={onClose}>
        &times; {/* Close icon (X) */}
      </button>
      <div className="drawer-content">
        <p className="upload-text">Upload documents to complete this lifecycle</p>
        {/* Grey Box 1 */}
        {set1.length ? (
          <div className="content-box">
            <span className='document-head'>Set - 1</span>
            {set1.map((s1, idx1) => (
              <div className="inner-content" key={idx1}>
                <div className="left-box">{idx1 + 1}. {s1.documentname}</div>
                <div className="right-box">
                  {s1.actualfilename != null ? (
                    <a
                      onClick={() => {
                        window.open(`${baseUrl}downloadcandidatedocument/${candidateuuid}/${s1.actualfilename}`, "_blank");
                      }}
                    >
                      <CloudDownload
                        className="upload-icon"
                        style={{ cursor: 'pointer', fontSize: '30px' }}
                      />
                    </a>
                  ) : (
                    <>
                      <span className="status-text">Pending</span>
                      <ErrorOutlineIcon className="exclamation-icon" />
                    </>
                  )}
                  <a>
                    <CloudUploadIcon
                      className="upload-icon"
                      onClick={() => { triggerFileInput1(idx1) }}
                      style={{ cursor: 'pointer', fontSize: '30px' }}
                    />
                  </a>
                  <input
                    type="file"
                    id={`fileInput1-${idx1}`}
                    accept=".pdf"
                    style={{ display: 'none' }}
                    onChange={(e) => { handleFileChange(e, s1.documentid) }}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : null}

        {/* Grey Box 2 */}
        {set2.length ? (
          <div className="content-box">
            <span className='document-head'>Set - 2</span>
            {set2.map((s2, idx2) => (
              <div className="inner-content" key={idx2}>
                <div className="left-box">{idx2 + 1}. {s2.documentname}</div>
                <div className="right-box">
                  {s2.actualfilename != null ? (
                    <a
                      onClick={() => {
                        window.open(`${baseUrl}downloadcandidatedocument/${candidateuuid}/${s2.actualfilename}`, "_blank");
                      }}
                    >
                      <CloudDownload
                        className="upload-icon"
                        style={{ cursor: 'pointer', fontSize: '30px' }}
                      />
                    </a>
                  ) : (
                    <>
                      <span className="status-text">Pending</span>
                      <ErrorOutlineIcon className="exclamation-icon" />
                    </>
                  )}
                  <a>
                    <CloudUploadIcon
                      className="upload-icon"
                      onClick={() => { triggerFileInput2(idx2) }}
                      style={{ cursor: 'pointer', fontSize: '30px' }}
                    />
                  </a>
                  <input
                    type="file"
                    id={`fileInput2-${idx2}`}
                    accept=".pdf"
                    style={{ display: 'none' }}
                    onChange={(e) => { handleFileChange(e, s2.documentid) }}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Drawer;
